import { render, staticRenderFns } from "./onboarding-modal.vue?vue&type=template&id=49c5cdd4&scoped=true"
import script from "./onboarding-modal.vue?vue&type=script&lang=js"
export * from "./onboarding-modal.vue?vue&type=script&lang=js"
import style0 from "./onboarding-modal.vue?vue&type=style&index=0&id=49c5cdd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5cdd4",
  null
  
)

export default component.exports